import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=cd416c18&scoped=true&"
import script from "./Mailing.vue?vue&type=script&lang=js&"
export * from "./Mailing.vue?vue&type=script&lang=js&"
import style0 from "./Mailing.vue?vue&type=style&index=0&id=cd416c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd416c18",
  null
  
)

export default component.exports